import { z } from "zod";
import { rulesSchema, tempoSchema, variantSchema } from "./table";
/** What a player set up last for one game: its target and its house rules. */
export const gameChoiceSchema = z.object({
    goal: z.number().int().positive().nullable(),
    rules: rulesSchema,
});
/**
 * `GET`/`PUT /api/me/table` (slice 0038): the table a player set up last, so the next one starts
 * the same. The game, tempo and who may join are one choice; target and rules are kept per game.
 */
export const tableChoiceSchema = z.object({
    variant: variantSchema,
    tempo: tempoSchema,
    listed: z.boolean(),
    games: z.partialRecord(variantSchema, gameChoiceSchema),
});
/** `GET /api/me/table`: null before the first table. */
export const tableChoiceResponseSchema = z.object({ choice: tableChoiceSchema.nullable() });
//# sourceMappingURL=tableChoice.js.map